import { expected, isNil } from '@aloft/toolkit-shared';

import { useParams } from 'react-router';

import { useOrderStatusGuard } from '../hooks/useOrderStatusGuard.tsx';
import { CraftsmanOrderRootElement } from './CraftsmanOrderRootElement.tsx';
import { Tkv2OrderRootRouteElement } from './Tkv2OrderRootElement.tsx';

export const OrderRootElement = () => {
  const { orderId } = useParams();
  const orderID = expected(orderId);
  const { order, orderStatusModal } = useOrderStatusGuard(orderID);
  if (isNil(order.data)) return null;

  if (order.data.input.version === 2) {
    return (
      <>
        <CraftsmanOrderRootElement />
        {orderStatusModal}
      </>
    );
  }

  // still needed for legacy export
  return (
    <>
      <Tkv2OrderRootRouteElement />
      {orderStatusModal}
    </>
  );
};
